import type { ScreenSettings } from '@/lib/configuration'
import { playNewOrderChime, unlockSound } from '@/lib/sound'
import { Button } from './ui/button'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from './ui/dialog'

export function QuickSettings({
  open,
  onClose,
  settings,
  update,
  reset,
  restaurantId,
  displays,
}: {
  open: boolean
  onClose: () => void
  settings: ScreenSettings
  update: (settings: Partial<ScreenSettings>) => void
  reset: () => void
  restaurantId: string
  displays: { id: string; name?: string | null }[]
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        if (!value) onClose()
      }}
    >
      <DialogContent className="max-h-[85dvh] overflow-y-auto">
        <DialogTitle>Snabbinställningar</DialogTitle>
        <DialogDescription>Gäller tills sidan laddas om. Permanenta inställningar görs i backoffice.</DialogDescription>
        <label className="space-y-2">
          Tema
          <select
            className="w-full rounded border bg-card p-3"
            value={settings.colorScheme}
            onChange={(e) => {
              if (e.target.value === 'dark' || e.target.value === 'light' || e.target.value === 'high-contrast') update({ colorScheme: e.target.value })
            }}
          >
            <option value="dark">Mörkt</option>
            <option value="light">Ljust</option>
            <option value="high-contrast">Hög kontrast</option>
          </select>
        </label>
        <label>
          Textstorlek {settings.fontSizeMultiplier}%
          <input className="w-full" type="range" min="50" max="250" value={settings.fontSizeMultiplier} onChange={(e) => update({ fontSizeMultiplier: Number(e.target.value) })} />
        </label>
        <label>
          Volym {settings.soundVolume}%<input className="w-full" type="range" min="0" max="100" value={settings.soundVolume} onChange={(e) => update({ soundVolume: Number(e.target.value) })} />
        </label>
        <label className="flex items-center gap-3">
          <input type="checkbox" checked={settings.showItemCounter} onChange={(e) => update({ showItemCounter: e.target.checked })} />
          Visa artikelräknare
        </label>
        <label className="flex items-center gap-3">
          <input type="checkbox" checked={settings.slipFullHeight} onChange={(e) => update({ slipFullHeight: e.target.checked })} />
          Visa hela bongen
        </label>
        <Button
          variant="outline"
          onClick={() => {
            unlockSound()
            playNewOrderChime(settings.soundVolume)
          }}
        >
          Testa ljud
        </Button>
        <Button variant="outline" onClick={reset}>
          Återställ från backoffice
        </Button>
        <div className="space-y-2">
          <p>Byt skärm</p>
          {displays.map((display) => (
            <Button key={display.id} asChild variant="outline" className="w-full">
              <a href={`/${restaurantId}/${display.id}`}>{display.name ?? display.id}</a>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
